import { ShipmentSearchCriteria } from './ShipmentSearchCriteria';

export class ShipmentSearchExportCriteria {
  query?: ShipmentSearchCriteria;
  visibleColumns?: (string | undefined)[];

  constructor(opts?: Partial<ShipmentSearchExportCriteria>) {
    if (opts?.query != null) {
      this.query = opts.query;
    }
    if (opts?.visibleColumns != null) {
      this.visibleColumns = opts.visibleColumns.map((val) => val);
    }
  }
}
